import FormPageTemplate from './FormPageTemplate'

const ArchitectureNewApplicationPage = () => (
    <FormPageTemplate
        titleKey="admin.monday.new_application"
        subtitleKey="admin.monday.fill_details"
        defaultFormType="estimados_2026_new_app"
        returnPath="/architecture"
    />
)

export default ArchitectureNewApplicationPage
